import axios from "axios";
import type { DemoRow, DemoSeedResult } from "@/interfaces/demo";
import { apiClient } from "@/lib/apiClient";

/** Every committed demo bundle with its seeded state. GFG roles only (view DEMO). */
export async function fetchDemoRows(): Promise<DemoRow[]> {
  const { data } = await apiClient.get<{ success: boolean; rows: DemoRow[] }>("/admin/demo");
  return data.rows;
}

/** (Re)build one demo organization from its bundle. Super admin only (seed DEMO). Always replaces. */
export async function seedDemo(slug: string): Promise<DemoSeedResult> {
  try {
    const { data } = await apiClient.post<{ success: boolean; result: DemoSeedResult }>(
      `/admin/demo/${encodeURIComponent(slug)}/seed`,
    );
    return data.result;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data?.error) {
      throw new Error(error.response.data.error as string);
    }
    throw error;
  }
}
